import './index.css';
import '@i18n/config';
import config from '@config';
import clarity from '@microsoft/clarity';

import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import App from '@src/App';

// Initialize axe-core for accessibility testing (development only)
if (import.meta.env.DEV) {
  import('@axe-core/react').then((axe) => {
    axe.default(React, ReactDOM, 1000); // 1000ms debounce delay
  });
}

// Initialize Microsoft Clarity
if (config.analytics?.clarity?.projectId) {
  clarity.init(config.analytics.clarity.projectId);
}

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
